// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'Products/';
export const ProductActionTypes = {
  GALLERY: ActionHelper.createActionTypes(actionTypePrefix, 'GALLERY'),
  VERSIONS: ActionHelper.createActionTypes(actionTypePrefix, 'VERSIONS'),
};
